<template>
    <v-card class="pa-3" height="100%">
        <apexchart
        type="pie"
        height="360"
        :options="chart.incomeGroup.options"
        :series="chart.incomeGroup.series"
        ></apexchart>
    </v-card>
</template>
<script>
  import { mapGetters } from "vuex";  
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts,
    },
  data: () => ({
      chart: {
        incomeGroup: {
            series: [],
            options: {
                title: {
                text: "Dasher Income Overview",
                },
                noData: {
                text: "No data available",
                },
                chart: {
                type: "pie",
                toolbar: {
                    show: true,
                },
                },
                labels: [],
                colors: [
                "#9C27B0",
                "#71974c",
                "#00a0de",
                "#f9a01a",
                "#d34626",
                "#3E2723"
                ],
                legend: {
                show: true,
                position: "bottom",
                },
            },
        },
      }

    }),

    created() {
      // this.initialize();
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["income-group"]);
        this.updateCharts();
      },

      async updateCharts() {
        // Income Group Overview PIE Chart    
        this.chart.incomeGroup.options = {
          labels: this.indexData.income_overview.labels,
        };
        // Pie Chart has animaion issue. If the new series contains
        // more items then the animation doesn't work. To fix it
        // we first set the series dammy data, wait 50ms, and then
        // set with actual data  
        let fetched_data = this.indexData.income_overview.series;
        
        this.chart.incomeGroup.series = [1].concat(Array(fetched_data.length).fill(0));

        setTimeout(() => {
          this.chart.incomeGroup.series = fetched_data;
        }, 500);
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>